var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
var IosContext = createContext(null);
export default function useIosContext() {
    var context = useContext(IosContext);
    if (context === null) {
        throw new Error('useIosContext must be used within a IosContext');
    }
    return context;
}
export function IosContextProvider(props) {
    var children = props.children;
    var isIos = navigator.userAgent.match(/(iPod|iPhone|iPad)/) != null;
    var isIpad = navigator.userAgent.match(/(iPad)/) != null;
    var isIphone = navigator.userAgent.match(/(iPod|iPhone)/) != null;
    return (_jsx(IosContext.Provider, __assign({ value: {
            isIos: isIos,
            isIpad: isIpad,
            isIphone: isIphone,
        } }, { children: children })));
}
